import { render, staticRenderFns } from "./DB.vue?vue&type=template&id=e21025a8&scoped=true&"
import script from "./DB.vue?vue&type=script&lang=js&"
export * from "./DB.vue?vue&type=script&lang=js&"
import style0 from "./DB.vue?vue&type=style&index=0&id=e21025a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21025a8",
  null
  
)

export default component.exports